var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHambugerMenubar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.21429C6 4.54368 6.53728 4 7.2 4H22.8C23.4627 4 24 4.54368 24 5.21429C24 5.88489 23.4627 6.42857 22.8 6.42857H7.2C6.53728 6.42857 6 5.88485 6 5.21429ZM22.8 11.2857H1.2C0.537281 11.2857 0 11.8294 0 12.5C0 13.1706 0.537281 13.7143 1.2 13.7143H22.8C23.4627 13.7143 24 13.1706 24 12.5C24 11.8294 23.4627 11.2857 22.8 11.2857ZM22.8 18.5714H12C11.3373 18.5714 10.8 19.1151 10.8 19.7857C10.8 20.4563 11.3373 21 12 21H22.8C23.4627 21 24 20.4563 24 19.7857C24 19.1151 23.4627 18.5714 22.8 18.5714Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHambugerMenubar);
export default __webpack_public_path__ + "static/media/Hambuger_menubar.f3c78fda12a86980ecded60af76e3925.svg";
export { ForwardRef as ReactComponent };